import {AfriexAdminPermission} from '@afriex/core/domain/enums';

import {Pagination, TableSkeleton} from '@/components';
import type {PaginationProps} from '@/components/common/Pagination';
import {PermissionsProvider} from '@/components/common/PermissionsProvider';

import EventTierTiersTable from './EventTierTiersTable';
import EventTierUpdateButton from './EventTierUpdateButton';
import useEventTierList from './useEventTierList';

export const EventTierListTab = () => {
  const {isLoading, fetchList, total, list} = useEventTierList();

  return (
    <main className="my-5">
      <PermissionsProvider
        permission={AfriexAdminPermission.ReferralTierManage}
      >
        <div className="flex justify-end">
          <EventTierUpdateButton />
        </div>
      </PermissionsProvider>

      <section className="pt-5 md:pt-5">
        {isLoading ? <TableSkeleton /> : <EventTierTiersTable items={list} />}
      </section>

      {list && list.length ? (
        <Pagination
          onPageChange={fetchList as PaginationProps['onPageChange']}
          total={total}
          isSearch={false}
        />
      ) : null}
    </main>
  );
};
